<template>
  <div class="header">
    <div class="header-content">
      <!-- Logo 区域 -->
      <div class="logo-section" @click="router.push('/')">
        <img src="@/img/home/oumiAndName.webp" :alt="$t('header.logoAlt')" class="logo-icon">
      </div>
      
      <!-- Top Up 按钮 -->
      <div v-if="!flag" class="top-up-btn" @click="clickRecharge">
        {{ $t('header.topUp') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import router from '#/router'
import { ref } from 'vue'
const prop = defineProps({
  no_recharge: {
    type: Boolean,
    default: false
  }
})

const flag = ref(prop.no_recharge)

function clickRecharge() {
  const params = { text: '1aaaa', message: 1111 }
  router.push({ name: 'recharge', state: { params } })
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 124px;
  background: #000000;
  box-sizing: border-box;
  padding-top: 30px;
  padding-bottom: 30px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  .header-content {
    max-width: 1500px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;

    .logo-section {
      display: flex;
      align-items: center;
      gap: 12px;
      cursor: pointer;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 0.8;
      }

      .logo-icon {
        width: 187px;
        height: 60px;
        border-radius: 8px;
        object-fit: cover;
      }

      .logo-text {
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        font-family: 'Poppins', sans-serif;
      }
    }

    .top-up-btn {
      background: #FDF652;
      color: #000000;
      padding: 12px 31px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      font-family: 'Poppins', sans-serif;

      &:hover {
        background: #FFC700;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .header {
    height: 56px;

    .header-content {
      padding: 0 16px;

      .logo-section {
        gap: 8px;

        .logo-icon {
          width: 90px;
          height: 28px;
        }

        .logo-text {
          font-size: 18px;
        }
      }

      .top-up-btn {
        padding: 6px 16px;
        font-size: 13px;
      }
    }
  }
}

@media (max-width: 480px) {
  .header {
    height: 52px;

    .header-content {
      padding: 0 12px;

      .logo-section {
        .logo-icon {
          width: 90px;
          height: 28px;
        }

        .logo-text {
          font-size: 16px;
        }
      }

      .top-up-btn {
        padding: 5px 14px;
        font-size: 12px;
      }
    }
  }
}
</style>